import React from "react";
import { DragDrop } from "./DragDrop";
import { includes, shuffle } from "lodash";
import ReactHtmlParser from "react-html-parser";
import { Answer } from "../../components/answers/badge/answer";
import { handleDragStart, handleOverDrop } from "./DragDropEvents";
import Question from "../../components/question/question";
import { DragAndDropCrossMatchAndFillInQuestionReview } from "./DragAndDrop_CrossMatch_and_FillInQuestion_Review";

export const DragAndDropCrossMatch = React.memo(({
  question,
  converted,
  exercise_id,
  section_id,
  page_id,
  data_possible_type,
  isShowNumbering,
  qai,
  answer,
  isReview,
  Questionedit,
  data,
  isBlinking,
  focusblink,
  blurblink,
  setIsBlinking,
  isFielddisabled
}) => {
  return (
    <div>
      <div className="row">
        <div className={isReview ? "col-12" : "col-lg-10 col-md-10 col-12"}>
          <Question
            Questionedit={Questionedit}
            isBlinking={isBlinking}
            setIsBlinking={setIsBlinking}
            focusblink={focusblink}
            blurblink={blurblink}
            qai={qai}
            data={data}
            showNumbers={isShowNumbering}
            counterClass="me-2"
            counter={qai + 1 + "."}
            alignement={question.question_alignement}
            title={ReactHtmlParser(converted.replace(/\*([\d]+)/g, ""), {
              transform: (node) => {
                if (
                  node &&
                  node.attribs &&
                  includes(node.attribs["data-type"], "Drag")
                ) {
                  return isReview ? (
                    <DragAndDropCrossMatchAndFillInQuestionReview
                      question={question}
                      className={"d-inline"}
                      possible_answer_number={parseInt(node.attribs["data-id"])}
                    />
                  ) : (
                    <DragDrop
                      question={question}
                      exercise_id={exercise_id}
                      section_id={section_id}
                      page_id={page_id}
                      data_possible_type={data_possible_type}
                      answer={answer}
                      possible_answer_number={parseInt(node.attribs["data-id"])}
                    />
                  );
                }
              },
            })}
          />
        </div>
        {isReview ? null : (
          <div
            className="col-12 col-lg-2 col-md-2 text-end user-select bg-light border py-2"
            data-drop-target="true"
            data-reset-answer="true"
            data-question-id={question.id}
            onDrop={handleOverDrop(answer, true)}
            onDragOver={handleOverDrop(answer, true)}
            data-tc={"ListCrossMatch"}
          >
            {(question && question.possible_answers
            ).map((possible_answer, id) => {
              return (
                <div
                  className="mb-1 custom-badge-radius bg-primary w-100 "
                  id={`emptydiv${question.id}${possible_answer.id}`}
                  data-question-type={"CrossMatch"}
                  data-reset-answer="true"
                  data-question-id={question.id}
                >
                  <div
                    id={`box${id}${qai}`}
                    data-question-id={question.id}
                    data-question-type={"CrossMatch"}
                    data-possible-answer-id={possible_answer.id}
                    exercise_id={exercise_id}
                    section_id={section_id}
                    page_id={page_id}
                    data_possible_type={data_possible_type}
                    draggable={isFielddisabled ? "false" : "true"}
                    class="d-inline input_mb_1 text-wrap"
                    onDragStart={handleDragStart}
                  >
                    <Answer
                      id={`${question.id}${possible_answer.id}`}
                      data-box-id="answer"
                      badgeclass="text-wrap  badge dotted-border customized-badge  w-100 "
                      value={possible_answer.prompt_content}
                      data-box="box"
                      Questionedit={Questionedit}
                      qai={qai}
                      ans_key={id}
                      data={data}
                      focusblink={focusblink}
                      blurblink={blurblink}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
});
